import { brandsClient } from "./client";

const fetchBrands = () => brandsClient.get("/v1/brand");

export { fetchBrands };
